import * as tslib_1 from "tslib";
import { Button } from '@nextiva/next-ui';
import * as React from 'react';
import Styles from "./AddButton.css";
export default function AddButton(props) {
  return React.createElement(Button, tslib_1.__assign({}, props, {
    kind: "success",
    className: Styles.addButton
  }), props.children);
}